import React from "react";
import ProductIcon from "./ProductIcons";

export default function CriteriaFlow({ steps = [] }) {
  return (
    <ol className="flex flex-col gap-4 sm:flex-row sm:flex-wrap sm:items-center">
      {steps.map((step, index) => (
        <li key={step.title} className="flex items-center gap-4">
          <div className="min-w-0">
            <div className="flex items-center gap-2 text-sm font-semibold text-ink">
              {step.icon ? <ProductIcon name={step.icon} className="h-4 w-4 text-hint-deep" /> : null}
              {step.title}
            </div>
            <p className="mt-0.5 text-xs text-muted">{step.meta}</p>
          </div>
          {index < steps.length - 1 ? (
            <span className="hidden text-hint-deep sm:inline" aria-hidden="true">
              →
            </span>
          ) : null}
        </li>
      ))}
    </ol>
  );
}
